export namespace Random {
    export function int(a: number, b: number, inclusive: boolean = false) {
        return Math.floor((b - a + (inclusive ? 1 : 0)) * Math.random()) + a;
    }

    export function float(a: number, b: number) {
        return (b - a) * Math.random() + a;
    }
}